import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import useVehicleTypesLogic from "./useVehicleTypesLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "Name", label: "Name", allowSorting: true },
];

const VehicleTypesPage = () => {
  const { addRoles, deleteRoles, editRoles, initFields } =
    useVehicleTypesLogic();
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Vehcile Types." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"vehicle_type"}
        apiRoute={"vehicletypes"}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default VehicleTypesPage;
